import React, { useEffect, useState } from 'react'
import {S_IMAGE_GROUP_BY_CATEGORIES} from '../graphql/imageGroup';
import { useGqlRequest } from "@codecraftkit/use-gql-request";

/**
 * The avatars the backend offers for this user.
 *
 * `checkForAgencyToChooseAvatar` scopes the group to the user's agency, and with no agency on the
 * item it asks for nothing at all — which is deliberate: a group-wide list would show avatars
 * from another tenant.
 */
export const useGetAvatarDefaultImages = ({ item, key, skip, checkForAgencyToChooseAvatar }) => {
    const [avatars, setAvatars] = useState([])
    const { data: imageResponse, call: getImageGroup, loading: getImageLoading } = useGqlRequest(S_IMAGE_GROUP_BY_CATEGORIES);

    useEffect(() => {
        if (!skip) {
            if(checkForAgencyToChooseAvatar){
                if (item?.agency?._id) {
                    getImageGroup({ key: key || 'profile', agencyId: item?.agency?._id});
                }
            } else{
                getImageGroup({ key: key || 'profile'});
            }
        }
    }, [])

    useEffect(() => {
        if (imageResponse?.length) {
            setAvatars(imageResponse?.[0]?.images);
        }
    }, [imageResponse])

    return [
        avatars,
        getImageLoading
    ]
};
